import { render, staticRenderFns } from "./TransferingConsultation.vue?vue&type=template&id=64c03bd2&scoped=true&"
import script from "./TransferingConsultation.vue?vue&type=script&lang=js&"
export * from "./TransferingConsultation.vue?vue&type=script&lang=js&"
import style0 from "./TransferingConsultation.vue?vue&type=style&index=0&id=64c03bd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c03bd2",
  null
  
)

export default component.exports